import React, { useEffect, useState } from "react";
import SEO from "../SEO";
import { seoConfig } from "../config/seoConfig";
import { useNavigate } from "react-router-dom";
import "../Component2/css/Profile.css";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import JobsSAI from "./JobsSAI";
import { BASE_URL } from "../config/constants";
import SearchableDropdown from "../Component/SearchableDropdown";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../Component/commenuse/CropImage";

function Profile() {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  // Main
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  // Sub Category
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");

  // Sub Category 1
  const [subCat1, setSubCat1] = useState([]);
  const [selectedSubCat1, setSelectedSubCat1] = useState("");

  // Sub Category 2
  const [subCat2, setSubCat2] = useState([]);
  const [selectedSubCat2, setSelectedSubCat2] = useState("");

  // Sub Category 3
  const [subCat3, setSubCat3] = useState([]);
  const [selectedSubCat3, setSelectedSubCat3] = useState("");

  // ================= EDUCATION =================
  const [educationType, setEducationType] = useState("");
  const [educationDetail, setEducationDetail] = useState("");

  // const [aadhaarOtp, setAadhaarOtp] = useState("");
  // const [clientId, setClientId] = useState("");
  // const [aadhaarVerified, setAadhaarVerified] = useState(false);
  // const [showOtpBox, setShowOtpBox] = useState(false);
  // const [aadhaarLoading, setAadhaarLoading] = useState(false);

  const navigate = useNavigate();

  const educationOptions = {
    Diploma: ["D.Pharm"],
    Graduation: ["B.Sc", "B.Pharmacy"],
    "Post Graduation": ["M.Sc", "M.Pharm"],
  };

  // ================= STATE & CITY =================
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  // change password code
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const candidateId = localStorage.getItem("candidate_id");

  useEffect(() => {
    fetchStates();
  }, []);

  // const sendAadhaarOtp = async () => {
  //   if (!candidate.can_aadhar) {
  //     toast.error("Enter Aadhaar Number");
  //     return;
  //   }

  //   if (candidate.can_aadhar.length !== 12) {
  //     toast.error("Aadhaar must be 12 digits");
  //     return;
  //   }

  //   try {
  //     setAadhaarLoading(true);

  //     const res = await axios.post(`${BASE_URL}candidate/send-aadhaar-otp`, {
  //       aadhaar_number: candidate.can_aadhar,
  //     });

  //     if (res.data.status) {
  //       setClientId(res.data.client_id);
  //       setShowOtpBox(true);

  //       toast.success("OTP Sent Successfully");
  //     } else {
  //       toast.error(res.data.message);
  //     }
  //   } catch (err) {
  //     toast.error("OTP Send Failed");
  //   } finally {
  //     setAadhaarLoading(false);
  //   }
  // };

  // const verifyAadhaarOtp = async () => {
  //   if (!aadhaarOtp) {
  //     toast.error("Enter OTP");
  //     return;
  //   }

  //   try {
  //     setAadhaarLoading(true);

  //     const res = await axios.post(`${BASE_URL}candidate/verify-aadhaar-otp`, {
  //       client_id: clientId,
  //       otp: aadhaarOtp,
  //     });

  //     if (res.data.status) {
  //       setAadhaarVerified(true);

  //       toast.success("Aadhaar Verified Successfully");
  //     } else {
  //       toast.error("Invalid OTP");
  //     }
  //   } catch (err) {
  //     toast.error("OTP Verification Failed");
  //   } finally {
  //     setAadhaarLoading(false);
  //   }
  // };

  const fetchStates = async () => {
    try {
      const res = await axios.get(`${BASE_URL}candidate/getdata/tbl_state`);

      if (res.data?.status) {
        setStates(res.data.data || []);
      }
    } catch (err) {
      toast.error("State fetch error", err);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const res = await axios.get(
        `${BASE_URL}candidate/getdatawhere/tbl_city/city_state_id/${stateId}`,
      );

      if (res.data?.status) {
        setCities(res.data.data || []);
      }
    } catch (err) {
      toast.error("City fetch error", err);
    }
  };

  const handleStateChange = (e) => {
    const stateId = e.target.value;

    setCandidate((prev) => ({
      ...prev,
      can_state: stateId,
      can_city: "",
    }));

    if (stateId) {
      fetchCities(stateId);
    } else {
      setCities([]);
    }
  };

  const handleCityChange = (e) => {
    const cityId = e.target.value;

    setCandidate((prev) => ({
      ...prev,
      can_city: cityId,
    }));
  };

  //Main cat
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}candidate/getdata/tbl_main_category`,
      );
      setCategories(res.data.data || []);
    } catch (err) {
      toast.error("Main category error", err);
    }
  };

  //Sub cateagory
  useEffect(() => {
    if (selectedCategory) {
      fetchSubCategories(selectedCategory);
    } else {
      setSubCategories([]);
      setSelectedSubCategory("");
    }
  }, [selectedCategory]);

  const fetchSubCategories = async (mc_id) => {
    try {
      const res = await axios.get(
        `${BASE_URL}candidate/getdatawhere/tbl_subcategory/sc_mc_id/${mc_id}`,
      );
      setSubCategories(res.data.data || []);
    } catch (err) {
      toast.error("Sub category error", err);
    }
  };

  //Sub Categoray one
  useEffect(() => {
    if (selectedSubCategory) {
      fetchSubCat1(selectedSubCategory);
    } else {
      setSubCat1([]);
      setSelectedSubCat1("");
    }
  }, [selectedSubCategory]);

  const fetchSubCat1 = async (sc_id) => {
    try {
      const res = await axios.get(
        `${BASE_URL}candidate/getdatawhere/tbl_subcategory_1/sc1_sc_id/${sc_id}`,
      );
      setSubCat1(res.data.data || []);
    } catch (err) {
      toast.error("Sub category 1 error", err);
    }
  };

  //Sub Categoray Two
  useEffect(() => {
    if (selectedSubCat1) {
      fetchSubCat2(selectedSubCat1);
    } else {
      setSubCat2([]);
      setSelectedSubCat2("");
    }
  }, [selectedSubCat1]);

  const fetchSubCat2 = async (sc1_id) => {
    try {
      const res = await axios.get(
        `${BASE_URL}candidate/getdatawhere/tbl_subcategory_2/sc2_sc1_id/${sc1_id}`,
      );
      setSubCat2(res.data.data || []);
    } catch (err) {
      toast.error("Sub category 2 error", err);
    }
  };

  //Sub Categoray Three
  useEffect(() => {
    if (selectedSubCat2) {
      fetchSubCat3(selectedSubCat2);
    } else {
      setSubCat3([]);
      setSelectedSubCat3("");
    }
  }, [selectedSubCat2]);

  const fetchSubCat3 = async (sc2_id) => {
    try {
      const res = await axios.get(
        `${BASE_URL}candidate/getdatawhere/tbl_subcategory_3/sc3_sc2_id/${sc2_id}`,
      );
      setSubCat3(res.data.data || []);
    } catch (err) {
      toast.error("Sub category 3 error", err);
    }
  };

  const [candidate, setCandidate] = React.useState({
    can_id: "",
    can_state: "",
    can_city: "",
    can_image: "",
    can_aadhar: "",
    can_pan: "",
    can_resume: "",
    can_cv: "",
    can_experience: "",
    can_skill: "",
    can_education_type: "",
    can_education_detail: "",
    can_about: "",
    can_mc: "",
    can_sc: "",
    can_sc1: "",
    can_sc2: "",
    can_sc3: "",
    can_gender: "",
  });

  const [isAadharLocked, setIsAadharLocked] = useState(false);
  const [isPanLocked, setIsPanLocked] = useState(false);

  const [isCategorySynced, setIsCategorySynced] = useState(false); // ✅ ADD THIS

  const fetchCandidateProfile = async () => {
    try {
      const stored = localStorage.getItem("candidate");

      if (!stored) {
        navigate("/signin");
        return;
      }
      const lsData = JSON.parse(stored);

      const res = await axios.get(
        `${BASE_URL}candidate/getdatawhere/tbl_candidate/can_id/${lsData.can_id}`,
      );

      if (res.data?.status && res.data?.data?.length > 0) {
        const freshCandidate = res.data.data[0]; // ✅ DB latest data

        // ✅ if state exists then fetch cities
        if (
          freshCandidate?.can_state &&
          freshCandidate.can_state !== candidate.can_state
        ) {
          fetchCities(freshCandidate.can_state);
        }

        // ✅ update state
        setCandidate(freshCandidate);

        // ✅ update localStorage also
        localStorage.setItem("candidate", JSON.stringify(freshCandidate));
        setIsAadharLocked((freshCandidate.can_aadhar || "").length === 12);
        setIsPanLocked((freshCandidate.can_pan || "").length === 10);
      }
    } catch (err) {
      toast.error("Fetch candidate error", err);
    }
  };

  // ✅ ONLY SCORE FETCH (does not overwrite whole profile)
  const fetchCandidateScoreOnly = async () => {
    try {
      const stored = localStorage.getItem("candidate");
      if (!stored) return;

      const lsData = JSON.parse(stored);

      const res = await axios.get(
        `${BASE_URL}candidate/getdatawhere/tbl_candidate/can_id/${lsData.can_id}`,
      );

      if (res.data?.status && res.data?.data?.length > 0) {
        const freshCandidate = res.data.data[0];
        setCandidate((prev) => ({
          ...prev,
          can_score: freshCandidate.can_score,
        }));
      }
    } catch (err) {
      toast.error("Fetch score error", err);
    }
  };

  // ✅ SYNC only ONE time (so user selection won't override)
  useEffect(() => {
    if (!candidate || !candidate.can_id) return;
    if (isCategorySynced) return;

    setEducationType(candidate.can_education_type || "");
    setEducationDetail(candidate.can_education_detail || "");

    setSelectedCategory(candidate.can_mc || "");
    setSelectedSubCategory(candidate.can_sc || "");
    setSelectedSubCat1(candidate.can_sc1 || "");
    setSelectedSubCat2(candidate.can_sc2 || "");
    setSelectedSubCat3(candidate.can_sc3 || "");

    setIsCategorySynced(true);
  }, [candidate, isCategorySynced]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setCandidate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ============ Profile Update ============
  const handleUpdateProfile = async (e) => {
    e.preventDefault();

    if (!candidate?.can_id) {
      toast.error("Candidate ID missing");
      return;
    }

    const fileErrors = {
      can_aadhar: "aadhar number is required",
      can_pan: "pan number is required",
      can_resume: "Please upload Resume",
      can_image: "Please upload Profile Image",
      can_cv: "Please upload CV",
    };

    for (const key in fileErrors) {
      if (!candidate[key]) {
        toast.error(fileErrors[key]);
        return;
      }
    }

    // ✅ AADHAR VALIDATION (12 digits required)
    if (!candidate.can_aadhar || candidate.can_aadhar.length !== 12) {
      toast.error("Aadhar must be exactly 12 digits");
      return;
    }

    // if (!aadhaarVerified && !isAadharLocked) {
    //   toast.error("Please verify Aadhaar first");
    //   return;
    // }

    // ✅ PAN VALIDATION (10 characters required)
    if (!candidate.can_pan || candidate.can_pan.length !== 10) {
      toast.error("PAN must be exactly 10 characters");
      return;
    }

    if (!candidate.can_gender) {
      toast.error("Please select gender");
      return;
    }

    const categoryPayload = {};
    if (selectedCategory) categoryPayload.can_mc = selectedCategory;
    if (selectedSubCategory) categoryPayload.can_sc = selectedSubCategory;
    if (selectedSubCat1) categoryPayload.can_sc1 = selectedSubCat1;
    if (selectedSubCat2) categoryPayload.can_sc2 = selectedSubCat2;
    if (selectedSubCat3) categoryPayload.can_sc3 = selectedSubCat3;

    try {
      const payload = {
        can_experience: candidate.can_experience,
        can_skill: candidate.can_skill,
        can_about: candidate.can_about,
        can_state: candidate.can_state,
        can_city: candidate.can_city,
        can_gender: candidate.can_gender,

        ...categoryPayload,
        can_image: candidate.can_image,
        can_resume: candidate.can_resume,
        can_cv: candidate.can_cv,

        can_education_type: candidate.can_education_type,
        can_education_detail: candidate.can_education_detail,
      };

      // ✅ Aadhar/PAN only send if not locked
      if (!isAadharLocked) payload.can_aadhar = candidate.can_aadhar;
      if (!isPanLocked) payload.can_pan = candidate.can_pan;

      const response = await axios.post(
        `${BASE_URL}candidate/updatedata/tbl_candidate/can_id/${candidate.can_id}`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      const result = response.data;

      if (result?.status === true) {
        toast.success("Profile updated successfully ✅");

        const stateName =
          states.find((s) => s.state_id == candidate.can_state)?.state_name ||
          "";

        const cityName =
          cities.find((c) => c.city_id == candidate.can_city)?.city_name || "";

        const updatedCandidate = {
          ...candidate,

          can_score: result?.can_score || candidate.can_score,

          // ✅ IDs (DO NOT CHANGE)
          can_state: candidate.can_state,
          can_city: candidate.can_city,

          // ✅ Names (SEPARATE FIELDS)
          state_name: stateName,
          city_name: cityName,

          // OTHER FIELDS
          can_experience: candidate.can_experience,
          can_skill: candidate.can_skill,
          can_about: candidate.can_about,

          can_aadhar: candidate.can_aadhar,
          can_pan: candidate.can_pan,
          can_image: candidate.can_image,
          can_resume: candidate.can_resume,
          can_cv: candidate.can_cv,

          // Education
          can_education_type: candidate.can_education_type,
          can_education_detail: candidate.can_education_detail,

          can_mc: selectedCategory || candidate.can_mc,
          can_sc: selectedSubCategory || candidate.can_sc,
          can_sc1: selectedSubCat1 || candidate.can_sc1,
          can_sc2: selectedSubCat2 || candidate.can_sc2,
          can_sc3: selectedSubCat3 || candidate.can_sc3,
        };

        setCandidate(updatedCandidate);
        localStorage.setItem("candidate", JSON.stringify(updatedCandidate));

        // ✅ LOCK ONLY AFTER SUCCESSFUL UPDATE ✅
        if ((updatedCandidate.can_aadhar || "").length === 12)
          setIsAadharLocked(true);
        if ((updatedCandidate.can_pan || "").length === 10)
          setIsPanLocked(true);

        setTimeout(() => {
          const modalEl = document.getElementById("editProfileModal");
          if (modalEl && window.bootstrap) {
            const modalInstance =
              window.bootstrap.Modal.getInstance(modalEl) ||
              new window.bootstrap.Modal(modalEl);
            modalInstance.hide();
          }
        }, 800);
      } else {
        toast.error(result?.message || "Update failed");
      }
    } catch (error) {
      toast.error("UPDATE ERROR:", error);
      toast.error(error.response?.data?.message || "Server error. Try again.");
    }
  };

  const onSelectImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setShowCropper(true);
    };
    reader.readAsDataURL(file);
  };

  const onCropComplete = (_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  };

  const handleCropSave = async () => {
    const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels);

    const formData = new FormData();
    formData.append("can_image", croppedBlob, "profile.jpg");

    const res = await axios.post(`${BASE_URL}candidate/fileupload`, formData);

    if (res.data.status) {
      setCandidate((prev) => ({
        ...prev,
        can_image: res.data.files.can_image,
      }));
      toast.success("Profile image uploaded ✅");
      setShowCropper(false);
    }
  };

  // ============ File Upload API ============
  const uploadFile = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append(fieldName, file);

    try {
      const res = await axios.post(`${BASE_URL}candidate/fileupload`, formData);

      if (res.data.status) {
        const filename = res.data.files[fieldName];

        setCandidate((prev) => ({
          ...prev,
          [fieldName]: filename,
        }));

        toast.success("File uploaded successfully ✅");
      } else {
        toast.error("File not uploaded ❌");
      }
    } catch (err) {
      toast.error("File not uploaded ❌");
      toast.error(err);
    }
  };

  // change password
  const handleChangePassword = async () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match");
      return;
    }

    if (!candidate?.can_id) {
      toast.error("Candidate ID missing");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}candidate/change-password`,
        {
          candidate_id: candidate.can_id, // ✅ FIXED
          current_password: currentPassword,
          new_password: newPassword,
        },
      );

      if (response.data?.status) {
        toast.success("Password updated successfully ✅");

        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");

        document.querySelector("#changePasswordModal .btn-close")?.click();
      } else {
        toast.error(response.data?.message || "Current password is incorrect");
      }
    } catch (error) {
      toast.error(error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const totalPoints = 1000;
  const points = Number(candidate.can_score) || 0; // dynamic value
  const percentage = (points / totalPoints) * 100;
  // Smooth gradient ring (Green → Yellow → Red)
  const ringGradient = `
      conic-gradient(
        #fa4f00 0%,
        #ffc107 40%,
        #0d7904 100%
      )
    `;

  const scoreTextColor =
    percentage < 40 ? "#fa4f00" : percentage < 70 ? "#ffc107" : "#0d7904";

  useEffect(() => {
    // ✅ First time full profile load
    fetchCandidateProfile();

    // ✅ After that only score refresh every 5 sec
    const interval = setInterval(() => {
      fetchCandidateScoreOnly();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showCropper ? "hidden" : "auto";
  }, [showCropper]);

  return (
    <>
      {showCropper && (
        <div className="crop-overlay">
          <div className="crop-box">
            <div className="cropper-wrapper">
              <Cropper
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                aspect={1}
                cropShape="round"
                showGrid={false}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>

            <input
              type="range"
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(e) => setZoom(e.target.value)}
              className="form-range mt-3"
            />

            <div className="d-flex justify-content-end gap-2 mt-3">
              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowCropper(false)}
              >
                Cancel
              </button>
              <button className="btn btn-success" onClick={handleCropSave}>
                Crop & Save
              </button>
            </div>
          </div>
        </div>
      )}

      <SEO
        title={`${seoConfig.c_profile.title} - ${candidate?.can_name
          ?.split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")}`}
        description={seoConfig.c_profile.description}
      />

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

      <main className="container my-5">
        {/* ================= PROFILE CARD ================= */}
        <div className="card p-4">
          <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start gap-4 text-center text-md-start">
            {/* Profile Image */}
            <img
              src={
                candidate?.can_image
                  ? `${BASE_URL}Uploads/${candidate.can_image}`
                  : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
              }
              className="rounded-circle"
              width="90"
              height="90"
              alt="Candidate"
            />

            {/* Profile Info */}
            <div className="flex-grow-1">
              <h5 className="mb-1 fw-bold">
                {" "}
                {candidate.can_name
                  ?.toLowerCase()
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}
              </h5>
              <p className="mb-1 text-muted">
                {candidate.can_email?.toLowerCase()} | {candidate.can_mobile}
              </p>
              {candidate.can_city && candidate.can_state && (
                <p className="mb-0 text-muted">
                  {candidate.city_name}, {candidate.state_name}
                </p>
              )}
            </div>

            <div className="d-flex flex-column align-items-center align-items-md-end gap-2 mt-3">
              <button
                className="btn btn-outline-success px-4"
                data-bs-toggle="modal"
                data-bs-target="#editProfileModal"
                style={{ minWidth: "160px" }}
              >
                Edit Profile
              </button>

              <button
                className="btn btn-outline-danger px-4"
                data-bs-toggle="modal"
                data-bs-target="#changePasswordModal"
                style={{ minWidth: "160px" }}
              >
                Change Password
              </button>
            </div>

            {/* Progress Circle Center */}
            <div className="d-flex justify-content-center mt-2 ">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* Ring Circle */}
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    background: ringGradient,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  {/* Progress Overlay (empty part cover) */}
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      background: `conic-gradient(transparent ${percentage}%, #e9ecef ${percentage}%)`,
                      position: "absolute",
                      top: 0,
                      left: 0,
                    }}
                  />

                  {/* Inner white circle */}
                  <div
                    style={{
                      width: "65px",
                      height: "65px",
                      borderRadius: "50%",
                      background: "#fff",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 2,
                    }}
                  >
                    <h4 className="mb-0 fw-bold">{points}</h4>
                    <small className="text-muted">/ {totalPoints}</small>
                  </div>
                </div>

                {/* ✅ Score Text Bottom */}
                <p
                  className="mt-0 mb-0 fw-semibold"
                  style={{ color: scoreTextColor }}
                >
                  Credit Grade
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* change password model */}
        <div
          className="modal fade"
          id="changePasswordModal"
          tabIndex="-1"
          aria-labelledby="changePasswordModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5
                  className="modal-title"
                  id="changePasswordModalLabel"
                  style={{ fontWeight: "bold" }}
                >
                  Change Password
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleChangePassword();
                  }}
                >
                  {/* Current Password */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Current Password
                    </label>

                    <div className="input-group">
                      <input
                        type={showCurrent ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter current password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />

                      <span
                        className="input-group-text ms-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowCurrent(!showCurrent)}
                      >
                        <i
                          className={`fa-solid ${
                            showCurrent ? "fa-eye-slash" : "fa-eye"
                          }`}
                        ></i>
                      </span>
                    </div>
                  </div>

                  {/* New Password */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      New Password
                    </label>

                    <div className="input-group">
                      <input
                        type={showNew ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />

                      <span
                        className="input-group-text ms-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowNew(!showNew)}
                      >
                        <i
                          className={`fa-solid ${
                            showNew ? "fa-eye-slash" : "fa-eye"
                          }`}
                        ></i>
                      </span>
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Confirm Password
                    </label>

                    <div className="input-group">
                      <input
                        type={showConfirm ? "text" : "password"}
                        className="form-control"
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />

                      <span
                        className="input-group-text ms-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowConfirm(!showConfirm)}
                      >
                        <i
                          className={`fa-solid ${
                            showConfirm ? "fa-eye-slash" : "fa-eye"
                          }`}
                        ></i>
                      </span>
                    </div>
                  </div>
                  {/* Modal Footer */}
                  <div className="modal-footer">
                    <button
                      type="submit"
                      className="btn btn-success"
                      disabled={loading}
                    >
                      {loading ? "Updating..." : "Update Password"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <JobsSAI />
        </div>

        <div className="modal fade" id="editProfileModal" tabIndex="-1">
          <div className="modal-dialog modal-dialog-scrollable modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Profile</h5>
                <button className="btn-close" data-bs-dismiss="modal"></button>
              </div>

              {/* ================= MODAL BODY ================= */}
              <div className="modal-body px-4 py-2">
                {/* PROFILE IMAGE SECTION */}
                <div className="d-flex align-items-center gap-3 mb-3">
                  <img
                    src={
                      candidate?.can_image
                        ? `${BASE_URL}Uploads/${candidate.can_image}`
                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                    }
                    className="rounded-circle"
                    width="90"
                    height="90"
                    style={{ objectFit: "cover" }}
                  />

                  <div className="flex-grow-1">
                    <h5 className="mb-1 fw-bold">
                      {" "}
                      {candidate.can_name
                        ?.toLowerCase()
                        .split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ")}
                    </h5>
                    <p className="mb-1 text-muted">
                      {" "}
                      {candidate.can_email?.toLowerCase()}|{" "}
                      {candidate.can_mobile}
                    </p>
                    <p className="mb-0 text-muted"></p>
                  </div>
                </div>

                <hr className="my-2" />

                {/* BASIC DETAILS */}
                <h6 className="fw-bold mb-2">Professional Information</h6>
                <div className="row g-2 mb-2">
                  {/* state */}
                  <div className="col-md-6 mt-2">
                    <label className="fw-semibold">State</label>

                    <SearchableDropdown
                      value={candidate.can_state}
                      options={states}
                      placeholder="Select State"
                      searchPlaceholder="Search state..."
                      labelKey="state_name"
                      valueKey="state_id"
                      onChange={(value) => {
                        setCandidate((prev) => ({
                          ...prev,
                          can_state: value,
                          can_city: "", // reset city
                        }));
                        handleStateChange({ target: { value } });
                      }}
                    />
                  </div>

                  {/* city */}
                  <div className="col-md-6 mt-2">
                    <label className="fw-semibold">City</label>

                    <SearchableDropdown
                      value={candidate.can_city}
                      options={cities}
                      disabled={!candidate.can_state}
                      placeholder={
                        candidate.can_state
                          ? "Select City"
                          : "Select state first"
                      }
                      searchPlaceholder="Search city..."
                      labelKey="city_name"
                      valueKey="city_id"
                      onChange={(value) => {
                        setCandidate((prev) => ({
                          ...prev,
                          can_city: value,
                        }));
                        handleCityChange({ target: { value } });
                      }}
                    />
                  </div>

                  {/* aadhar number */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Aadhar Number
                    </label>

                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        className="form-control pe-5"
                        placeholder="Enter 12-digit Aadhar number"
                        value={candidate.can_aadhar || ""}
                        maxLength={12}
                        disabled={isAadharLocked}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          setCandidate((prev) => ({
                            ...prev,
                            can_aadhar: value,
                          }));

                        
                          // setAadhaarVerified(false);
                          // setShowOtpBox(false);
                          // setAadhaarOtp("");
                          // setClientId("");
                        }}
                      />

                      {/* ✅ RESET ONLY BEFORE FINAL SAVE */}
                      {!isAadharLocked &&
                        candidate.can_aadhar?.length === 12 && (
                          <span
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#dc3545",
                            }}
                            onClick={() => {
                              setCandidate((prev) => ({
                                ...prev,
                                can_aadhar: "",
                              }));
                            }}
                          >
                            <i className="fa fa-refresh"></i>
                          </span>
                        )}
                    </div>

                    {/* 🔒 FINAL LOCK MESSAGE */}
                    {isAadharLocked && (
                      <small className="text-danger">
                        Aadhar once saved cannot be changed.
                      </small>
                    )}
                  </div>
                  {/* <div className="col-md-4 mt-5 text-center">
                    <button
                      type="button"
                      className="btn btn-outline-success mt-2"
                      onClick={sendAadhaarOtp}
                      disabled={
                        aadhaarLoading ||
                        aadhaarVerified ||
                        candidate.can_aadhar.length !== 12
                      }
                    >
                      {aadhaarLoading ? "Sending..." : "Send OTP"}
                    </button>
                  </div>

                  {showOtpBox && !aadhaarVerified && (
                    <>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter OTP"
                          value={aadhaarOtp}
                          onChange={(e) => setAadhaarOtp(e.target.value)}
                        />
                      </div>

                      <div className="col-md-4 text-center">
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={verifyAadhaarOtp}
                          disabled={aadhaarLoading}
                        >
                          {aadhaarLoading ? "Verifying..." : "Verify OTP"}
                        </button>
                      </div>
                    </>
                  )}

                  {aadhaarVerified && (
                    <div className="col-md-12">
                      <small className="text-success fw-bold">
                        Aadhaar Verified Successfully ✅
                      </small>
                    </div>
                  )} */}
                  {/* pan number */}
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      PAN Card Number
                    </label>

                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        className="form-control pe-5"
                        placeholder="ABCDE1234F"
                        value={candidate.can_pan || ""}
                        maxLength={10}
                        style={{ textTransform: "uppercase" }}
                        disabled={
                          isPanLocked || (candidate.can_pan || "").length === 10
                        }
                        onChange={(e) => {
                          let value = e.target.value.toUpperCase();
                          value = value.replace(/[^A-Z0-9]/g, "");

                          if (value.length <= 5) {
                            value = value.replace(/[^A-Z]/g, "");
                          } else if (value.length <= 9) {
                            value =
                              value.slice(0, 5).replace(/[^A-Z]/g, "") +
                              value.slice(5).replace(/[^0-9]/g, "");
                          } else {
                            value =
                              value.slice(0, 5).replace(/[^A-Z]/g, "") +
                              value.slice(5, 9).replace(/[^0-9]/g, "") +
                              value.slice(9, 10).replace(/[^A-Z]/g, "");
                          }

                          setCandidate((prev) => ({
                            ...prev,
                            can_pan: value,
                          }));
                        }}
                      />

                      {/* ✅ RESET ONLY BEFORE SAVE */}
                      {!isPanLocked && candidate.can_pan?.length === 10 && (
                        <span
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#dc3545",
                          }}
                          onClick={() => {
                            setCandidate((prev) => ({
                              ...prev,
                              can_pan: "",
                            }));
                          }}
                        >
                          <i className="fa fa-refresh"></i>
                        </span>
                      )}
                    </div>

                    {isPanLocked && (
                      <small className="text-danger">
                        PAN once saved cannot be changed.
                      </small>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="fw-semibold">Gender</label>

                    <select
                      className="form-select form-control"
                      name="can_gender"
                      value={candidate.can_gender || ""}
                      onChange={(e) =>
                        setCandidate((prev) => ({
                          ...prev,
                          can_gender: e.target.value,
                        }))
                      }
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div className="col-md-6" style={{ marginTop: "36px" }}>
                    {" "}
                    <label className="btn btn-outline-success w-100">
                      {" "}
                      {candidate.can_image ? (
                        <>
                          <i className="fa-solid fa-circle-check text-success"></i>{" "}
                          <span className="text-success fw-semibold">
                            Profile Image Uploaded
                          </span>
                        </>
                      ) : (
                        <>
                          <i className="fa fa-upload text-muted"></i>{" "}
                          <span className="text-muted">Profile Image</span>
                        </>
                      )}
                      <input
                        type="file"
                        hidden
                        accept=".jpg,.jpeg,.png"
                        onChange={onSelectImage}
                      />{" "}
                      <input
                        type="hidden"
                        name="can_image"
                        value={candidate.can_image}
                      />
                    </label>{" "}
                  </div>

                  <div className="col-md-6">
                    {" "}
                    <label className="btn btn-outline-success w-100">
                      {" "}
                      {candidate.can_resume ? (
                        <>
                          <i className="fa-solid fa-circle-check text-success"></i>{" "}
                          <span className="text-success fw-semibold">
                            Resume Uploaded
                          </span>
                        </>
                      ) : (
                        <>
                          <i className="fa fa-upload text-muted"></i>{" "}
                          <span className="text-muted">
                            Upload Resume (PDF)
                          </span>
                        </>
                      )}
                      <input
                        type="file"
                        hidden
                        accept=".pdf"
                        onChange={(e) => uploadFile(e, "can_resume")}
                      />{" "}
                      <input
                        type="hidden"
                        name="can_resume"
                        value={candidate.can_resume}
                      />
                    </label>{" "}
                  </div>

                  <div className="col-md-6">
                    {" "}
                    <label className="btn btn-outline-success w-100">
                      {" "}
                      {candidate.can_cv ? (
                        <>
                          <i className="fa-solid fa-circle-check text-success"></i>{" "}
                          <span className="text-success fw-semibold">
                            CV Uploaded
                          </span>
                        </>
                      ) : (
                        <>
                          <i className="fa fa-upload text-muted"></i>{" "}
                          <span className="text-muted">Cover Letter(PDF)</span>
                        </>
                      )}
                      <input
                        type="file"
                        hidden
                        accept=".pdf"
                        onChange={(e) => uploadFile(e, "can_cv")}
                      />{" "}
                      <input
                        type="hidden"
                        name="can_cv"
                        value={candidate.can_cv}
                      />
                    </label>{" "}
                  </div>

                  <div className="col-md-6">
                    <label className="fw-semibold">Education Type</label>
                    <select
                      className="form-select form-control"
                      value={educationType}
                      onChange={(e) => {
                        const val = e.target.value;
                        setEducationType(val);
                        setEducationDetail("");

                        setCandidate((prev) => ({
                          ...prev,
                          can_education_type: val,
                          can_education_detail: "",
                        }));
                      }}
                    >
                      <option value="">Select Education</option>
                      <option value="Diploma">Diploma</option>
                      <option value="Graduation">Graduation</option>
                      <option value="Post Graduation">Post Graduation</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="fw-semibold">Education Detail</label>

                    {educationType === "Other" ? (
                      <input
                        type="text"
                        className="form-control round-3"
                        placeholder="Enter Education Detail"
                        value={educationDetail}
                        onChange={(e) => {
                          setEducationDetail(e.target.value);
                          setCandidate((prev) => ({
                            ...prev,
                            can_education_detail: e.target.value,
                          }));
                        }}
                      />
                    ) : (
                      <select
                        className="form-select form-control"
                        value={educationDetail}
                        disabled={!educationType}
                        onChange={(e) => {
                          setEducationDetail(e.target.value);
                          setCandidate((prev) => ({
                            ...prev,
                            can_education_detail: e.target.value,
                          }));
                        }}
                      >
                        <option value="">Select</option>
                        {educationOptions[educationType]?.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="fw-semibold">Experience</label>
                    <input
                      type="number"
                      name="can_experience"
                      className="form-control form-control-md"
                      placeholder="Experience"
                      value={candidate.can_experience}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="fw-semibold">Skills</label>
                    <input
                      type="text"
                      name="can_skill"
                      className="form-control form-control-md"
                      placeholder="Skills"
                      value={candidate.can_skill}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12">
                    <label className="fw-semibold">Describe Self</label>
                    <textarea
                      name="can_about"
                      className="form-control form-control-md"
                      rows="2"
                      placeholder="Briefly describe yourself"
                      value={candidate.can_about}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>

                {/* Categorys */}
                <h6 className="fw-bold mb-2">Category</h6>

                <div className="row g-2">
                  <div className="col-md-6">
                    <select
                      className="form-control form-select rounded-3"
                      value={selectedCategory}
                      onChange={(e) => {
                        const val = e.target.value;
                        setSelectedCategory(val);

                        // ✅ reset next dropdowns
                        setSelectedSubCategory("");
                        setSelectedSubCat1("");
                        setSelectedSubCat2("");
                        setSelectedSubCat3("");
                      }}
                    >
                      <option value="">Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat.mc_id} value={cat.mc_id}>
                          {cat.mc_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <select
                      className="form-control form-select rounded-3"
                      value={selectedSubCategory}
                      onChange={(e) => {
                        const val = e.target.value;
                        setSelectedSubCategory(val);

                        setSelectedSubCat1("");
                        setSelectedSubCat2("");
                        setSelectedSubCat3("");
                      }}
                      disabled={!selectedCategory || subCategories.length === 0}
                    >
                      <option value="">
                        {!selectedCategory
                          ? "Select Main Category first"
                          : subCategories.length === 0
                            ? "No sub categories available"
                            : "Select"}
                      </option>

                      {subCategories.map((sub) => (
                        <option key={sub.sc_id} value={sub.sc_id}>
                          {sub.sc_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <select
                      className="form-control form-select rounded-3"
                      value={selectedSubCat1}
                      onChange={(e) => {
                        const val = e.target.value;
                        setSelectedSubCat1(val);

                        setSelectedSubCat2("");
                        setSelectedSubCat3("");
                      }}
                      disabled={!selectedSubCategory || subCat1.length === 0}
                    >
                      <option value="">
                        {!selectedSubCategory
                          ? "Select Sub Category first"
                          : subCat1.length === 0
                            ? "No sub category available"
                            : "Select"}
                      </option>

                      {subCat1.map((item) => (
                        <option key={item.sc1_id} value={item.sc1_id}>
                          {item.sc1_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <select
                      className="form-control form-select rounded-3"
                      value={selectedSubCat2}
                      onChange={(e) => {
                        const val = e.target.value;
                        setSelectedSubCat2(val);

                        setSelectedSubCat3("");
                      }}
                      disabled={!selectedSubCat1 || subCat2.length === 0}
                    >
                      <option value="">
                        {!selectedSubCat1
                          ? "Select previous category first"
                          : subCat2.length === 0
                            ? "No sub category available"
                            : "Select"}
                      </option>

                      {subCat2.map((item) => (
                        <option key={item.sc2_id} value={item.sc2_id}>
                          {item.sc2_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <select
                      className="form-control form-select rounded-3"
                      value={selectedSubCat3}
                      onChange={(e) => setSelectedSubCat3(e.target.value)}
                      disabled={!selectedSubCat2 || subCat3.length === 0}
                    >
                      <option value="">
                        {!selectedSubCat2
                          ? "Select previous category first"
                          : subCat3.length === 0
                            ? "No sub category available"
                            : "Select"}
                      </option>

                      {subCat3.map((item) => (
                        <option key={item.sc3_id} value={item.sc3_id}>
                          {item.sc3_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* ================= MODAL FOOTER ================= */}
              <div className="modal-footer border-0 px-4 py-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary rounded-3"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-success px-4 ms-auto"
                  onClick={handleUpdateProfile}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Profile;
